namespace TabAurous.Inventory {
    export interface MeltingItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherDate: Serenity.DateEditor;
        RefVoucherId: Serenity.IntegerEditor;
        DepartmentId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        RoutingId: Serenity.DecimalEditor;
        GroupId: Serenity.DecimalEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        Studded: Serenity.IntegerEditor;
        Weight: WeightEditor;
        NetWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        CalcOnId: Serenity.LookupEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        ImageName: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
    }

    export class MeltingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.MeltingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MeltingItemsForm.init)  {
                MeltingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = WeightEditor;
                var w5 = s.LookupEditor;

                Q.initFormType(MeltingItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'VoucherTypeId', w1,
                    'VoucherDate', w2,
                    'RefVoucherId', w1,
                    'DepartmentId', w1,
                    'Line_No', w0,
                    'BagNo', w0,
                    'SKU', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'RefNo', w0,
                    'RoutingId', w3,
                    'GroupId', w3,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'AttributeId', w0,
                    'Studded', w1,
                    'Weight', w4,
                    'NetWeight', w4,
                    'Purity', w3,
                    'PureWeight', w4,
                    'CalcOnId', w5,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'ImageName', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w2,
                    'CompanyId', w1,
                    'BagStatus', w0
                ]);
            }
        }
    }
}
